import React, { FC } from 'react';
import './Result.scss';
import { IResultProps } from './IResultProps';
import { IRegelverkResult } from '../../../../Models/IResult';
import { getLanguage } from '../../../../utils/searchHelpers';
//import { handleLinkClick} from '../../../../utils/recordPageClickHandler';
import { Card, Heading, Paragraph, Tag } from '@udir-design/react/beta';
import { getContentType, getLastModified, getIntroTitleHtml} from '../../../../utils/resultHelpers';
import { DisplayFormat } from '../../../../Models/DisplayFormat';
import { getCurrentDisplayFormat } from '../../../../utils/generalHelpers';

const Result: FC<IResultProps> = (props) => {
    let { result } = props
    let language_attr = getLanguage(result);
    const isMobile = getCurrentDisplayFormat() === DisplayFormat.Mobile;
    const displayTitle = result.udirtitle ? result.udirtitle : result.title;
    
    //const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    //    const queryText = props.queryText || '';
    //    handleLinkClick(result.Url, result, queryText);
    //};
    
    
    const shouldShowDate = !!result.datoendret
        && !!result.innholdstype
        && result.innholdstype !== "Tema"
        && result.innholdstype !== "Paragrafer i forskrift"
        && result.innholdstype !== "Paragrafer i lov";
    const dateFormatted = shouldShowDate ? getLastModified(result) : undefined;
    return (
        <Card className="ResultLinkCard" key={`resultDisplay-${props.idx}`}>
            <Card.Block className="LinkCard__container">
                <div className={`LinkCard`}>
                    <Paragraph className="LinkCard__headerandsubtitle" data-size="sm">
                        <span className="subtitle-top title">{getContentType(result)}</span>
                        <span className="subtitle-top introtitle">{getIntroTitleHtml(result)}</span>
                        {dateFormatted && (
                            <span className="subtitle-top date">{dateFormatted}</span>
                        )}
                    </Paragraph>
                    
                    <Heading level={2}>
                        <a className={`cardtitle`} href={result.Url} rel="noopener noreferrer">
                            {displayTitle}
                        </a>
                    </Heading>

                    {getTeaserText(result, language_attr).length > 0 && getTeaserText(result, language_attr)}

                    {((result.regelverkslov && result.regelverkslov.trim().length > 0) || result.gyldighet === "Utgått innhold") && (
                        <div className='TagGroup metadata' data-size={isMobile ? 'sm' : 'md'}>
                            {result.regelverkslov && result.regelverkslov.trim().length > 0 && (
                                <Tag data-color="accent">
                                    {result.regelverkslov}
                                </Tag>
                            )}
                            {result.gyldighet === "Utgått innhold" && (
                                <Tag data-color="warning">
                                    Utgått
                                </Tag>
                            )}
                        </div>
                    )}
                </div>
            </Card.Block>
        </Card>
    )
}

const getTeaserText = (result: IRegelverkResult, language_attr) => {
    let teaserElement: React.ReactElement[] = [];
    // Paragrafer skal aldri ha teaser
    if (result.innholdstype === "Paragrafer i lov" || result.innholdstype === "Paragrafer i forskrift") {
        return teaserElement;
    }
    const hasDescription = result.description !== null && result.description !== undefined
        && result.description !== "" && result.description !== "&nbsp;" && result.description !== "&nbsp;\n&nbsp;";
    const qs = window.location.search;
    const isEmptySearch = qs === "" || qs === '?query=' || qs === '?query=*' || qs.indexOf('query=*') !== -1 || qs.indexOf('query=') === -1;
    if (hasDescription) {
        // Bruk highlightet description ved aktivt søk, ellers ren description
        const descriptionHtml = (!isEmptySearch && result.hhdescription) ? result.hhdescription : result.description;
        teaserElement.push(<div key="teaser-1" {...language_attr} dangerouslySetInnerHTML={{__html: descriptionHtml}} />);
    } else if (!isEmptySearch && result.hhsummary && result.hhsummary.trim() !== "") {
        // Ingen description: fall tilbake til dynamisk hhsummary, men kun ved aktivt søk
        teaserElement.push(<div key="teaser-2" {...language_attr} dangerouslySetInnerHTML={{__html: result.hhsummary}} />);
    }
    return teaserElement;
}

export default Result;